<template>
    <div class="Instructions">
        <!-- 兑换说明 -->
        <div class="InstructionsBox">
            <div class="conversion">
                <div class="title">兑换说明：</div>
                <div class="conversion_Con">
                    <div class="headline">实物礼品的邮费及配送说明</div>
                    <div v-html="instructionsForm.aboutPostage"></div>
                </div>
                <div class="conversion_Con">
                    <div class="headline">退换货政策</div>
                    <div v-html="instructionsForm.returnExchangeDesc"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as API from '@/api/user';
export default {
    name: 'Instructions',
    data() {
        return {
            instructionsForm: {}
        }
    },
    methods: {
        // 获取商城文案
        GetMallCopywriter() {
            API.getPointCopywriteInfo().then(res => {
                if(res.code === 20000) {
                    this.instructionsForm = res.data;
                    this.$emit("GetChildInfo", res.data);
                }
            });
        }
    },
    mounted() {
        this.GetMallCopywriter();
    }
}
</script>

<style scoped>
.Instructions{
    margin-top: 80px;
}
.Instructions .InstructionsBox {
    width: 1280px;
    margin: 0 auto;
}
.Instructions .InstructionsBox .conversion {
    padding: 24px 36px;
    border: 1px solid #989797;
}
.Instructions .InstructionsBox .conversion .title {
    color: #3880ca;
    font-size: 18px;
    text-align: left;
    font-weight: 600;
}
.Instructions .InstructionsBox .conversion .headline {
    border-bottom: 1px solid;
    text-align: left;
    padding-bottom: 4px;
    font-weight: 600;
    margin-bottom: 10px;
}
.Instructions .InstructionsBox .conversion .content {
    text-align: left;
    line-height: 28px;
}
.Instructions .InstructionsBox .introduction {
    text-align: center;
    padding: 30px;
    border-bottom: 1px solid #989797;
    margin-top: 80px;
}
.Instructions .InstructionsBox .conversion .conversion_Con {
    margin-top: 16px;
    text-align: left;
}
</style>